module.exports = __webpack_public_path__ + "img/site_title_noyear.0915469a.svg";